module.exports = __webpack_public_path__ + "img/icon03.8c8afc66.png";